import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { RouteErrorDisplay } from '@/components/RouteErrorDisplay'

export const Route = createFileRoute('/app/classes/create')({
  component: lazyRouteComponent(() => import('./-create')),
  errorComponent: ({ error }) => (
    <QueryErrorResetBoundary>
      {({ reset }) => <RouteErrorDisplay error={error} reset={reset} />}
    </QueryErrorResetBoundary>
  ),
})
